import { Layout } from 'antd';
import React from 'react';

import styles from './layout.module.less';

const { Footer } = Layout;

type TProps = {
  title?: string;
};

export const LayoutFooter: React.FC<TProps> = (props) => (
  <Footer className={styles.footer}>{props.title}</Footer>
);
